/**
 * @fileoverview POST handler for the "/apps/:app_group_id/user_imports/:import_id/event_catalog_slice" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postAppsAppGroupIdUserImportsImportIdEventCatalogSliceCacheKeys } from "./constants";
import type {
  PostAppsAppGroupIdUserImportsImportIdEventCatalogSliceProps,
  PostAppsAppGroupIdUserImportsImportIdEventCatalogSliceResult,
} from "./types";

const DATA_MAPPER_MUTATION_FETCH_SETTINGS = {
  propagateFetchRequestError: false,
};

export const postAppsAppGroupIdUserImportsImportIdEventCatalogSlice = reactQueryMutationAdapter(
  postAppsAppGroupIdUserImportsImportIdEventCatalogSliceCacheKeys,
  ({
    appGroupId,
    importId,
    eventNames,
  }: PostAppsAppGroupIdUserImportsImportIdEventCatalogSliceProps): Promise<PostAppsAppGroupIdUserImportsImportIdEventCatalogSliceResult> => {
    return fetch(
      `/apps/${appGroupId}/user_imports/${importId}/event_catalog_slice`,
      "POST",
      { event_names: eventNames },
      {},
      DATA_MAPPER_MUTATION_FETCH_SETTINGS
    );
  }
);
